// Import the generic hook
import useEntity from "../generic/useEntity.jsx";

// API
import { getTask } from "../../api/tasks.jsx";

// Redux actions
import { setSelectedTask, clearSelectedTask } from "../../redux/slices/clientBoardSlice";

/**
 * Custom hook for fetching task details
 * Wrapper around generic useEntity hook for backward compatibility
 * @param {string} taskId - ID of the task to fetch
 * @param {boolean} enabled - Whether the fetch should be enabled
 * @returns {Object} Object containing task from store, loading state, error and refetch function
 */
const useTask = (taskId, enabled = true) => {
  const config = {
    fetchFn: getTask,
    selectFn: (state) => state.clientBoard.selectedTask,
    setActionFn: setSelectedTask,
    clearActionFn: clearSelectedTask,
    entityName: "task"
  };

  const result = useEntity(taskId, enabled, config);

  return {
    task: result.task,
    isLoading: result.isLoading,
    error: result.error,
    refetch: result.refetch
  };
};

export default useTask;
